
export enum CountryCd {
	CANADA = 'Canada',
	MEXICO = 'Mexico',
	UNITED_STATES = 'UnitedStates'}

